"use client";

import Link from "@casino/client/components/Link";
import Img from "@casino/legacyUi/Img";

type Props = {
  handle: string;
  name: string;
  iconSrc: string;
};

const CategoryCard: FC<Props> = ({ handle, name, iconSrc }) => (
  <Link href={`/categories/${handle}`}>
    <div className="relative flex min-h-[140px] w-[100px] flex-col flex-wrap items-center justify-between rounded-lg bg-secondary px-2 pb-3 pt-4 text-center">
      <Img src={iconSrc} alt={name} width={64} height={64} />
      <p className="font-headline font-medium">{name}</p>
    </div>
  </Link>
);

export default CategoryCard;
